<template>
  <v-snackbar
    v-if="messagesNotAcceptable"
    :timeout="messagesNotAcceptable.timeout"
    v-model="situacaoSnack"
    :color="messagesNotAcceptable.type"
    top
  >
    <v-container v-if="validateMessages()">
      <v-row style="font-weight: bold;"
        >{{ messagesNotAcceptable.title }}
      </v-row>
      <v-row :key="i" v-for="(message, i) in messagesNotAcceptable.errors">
        <li>{{ message }}</li></v-row
      >
    </v-container>

    <template v-slot:action="{ attrs }">
      <v-btn color="white" icon v-bind="attrs" @click="onClose()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import store from "../../modules/notifications/_store";
export default {
  data: function() {
    return {
      iconsTypes: {
        warning: "icon-danger",
        error: "icon-alert-1",
        success: ""
      },
      value: ""
    };
  },
  computed: {
    ...mapGetters({
      messagesNotAcceptable: "$_messages/errorsNotAcceptable"
    }),
    situacaoSnack: {
      get: function() {
        if (
          Object.prototype.hasOwnProperty.call(
            this.messagesNotAcceptable,
            "title"
          )
        ) {
          return true;
        }
        return false;
      },
      set: function() {
        this.onClose();
      }
    }
  },
  methods: {
    onClose() {
      this.$store.dispatch("$_messages/destroyErrorsNotAcceptable");
    },
    timeout() {
      if (
        Object.prototype.hasOwnProperty.call(
          this.messagesNotAcceptable,
          "timeout"
        )
      ) {
        setTimeout(() => {
          this.$store.dispatch("$_messages/destroyErrorsNotAcceptable");
        }, this.messagesNotAcceptable.timeout);
      }
      return true;
    },
    validateMessages() {
      if (_.hasIn(this.messagesNotAcceptable, "errors")) return true;
      else false;
    }
  },
  created() {
    const STORE_KEY = "$_messages";
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }
};
</script>
